
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/scenes",
      function () {
        return require("private-next-pages/app/scenes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/scenes"])
      });
    }
  